import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { Carrier } from '../../user-dashboard/shared/carrier.model';
import { Region } from '../../user-dashboard/shared/region.model';
import { TranslateService } from '@ngx-translate/core';
import { TimeZone } from '../../realtime-tracking/shared/time-zone.model';

@Component({
  selector: 'app-page-heading',
  templateUrl: './page-heading.component.html',
  styleUrls: ['./page-heading.component.scss']
})
export class PageHeadingComponent implements OnInit {

  @Input()
  key: String;

  @Input()
  i18nParams: any;

  @Input()
  title: String;

  @Input()
  subheadingIcon: String;

  @Input()
  subheadingLabelKey: String;

  @Input()
  subInfoLabelKey: String;

  @Input()
  disableMarginBottom = false;

  @Input()
  clearable = true;

  @Input()
  forceShowCarrier = false;

  @Input()
  needVendorNumber = false;

  @Input()
  carriers: Carrier[] = [];

  @Input()
  selectedCarrier: Carrier;

  private _carrierSelectPlaceholderKey = 'selects.carriers.default-placeholder';
  public carrierSelectPlaceholderText: string;

  @Input()
  timeZonesOptions: TimeZone[];

  @Input()
  selectedTimeZone: TimeZone;

  @Output()
  selectedCarrierChange = new EventEmitter<Carrier>();

  @Output()
  selectedTimeZoneChange = new EventEmitter<TimeZone>();

  @Input()
  regions: Region[] = [];

  @Input()
  selectedRegion: Region;

  @Output()
  selectedRegionChange = new EventEmitter<Region>();

  @Input()
  helper = false;

  @Input()
  helperContent: TemplateRef<any>;

  helperActive = false;

  @Input()
  info = false;

  @Input()
  timeZone = false;

  @Input()
  infoMessageKey: string;

  @Input()
  set carrierSelectPlaceholderKey(carrierSelectPlaceholderKey: string) {
    this._carrierSelectPlaceholderKey = carrierSelectPlaceholderKey;
    this.carrierSelectPlaceholderText = null;
    if (carrierSelectPlaceholderKey) {
      this.translateService.get(carrierSelectPlaceholderKey).subscribe(t => this.carrierSelectPlaceholderText = t);
    }
  }

  constructor(private translateService: TranslateService) {}

  ngOnInit() {
  }

  carrierChanged() {
    this.selectedCarrierChange.emit(this.selectedCarrier);
  }

  timeZoneChanged() {
    this.selectedTimeZoneChange.emit(this.selectedTimeZone);
  }

  regionChanged() {
    this.selectedRegionChange.emit(this.selectedRegion);
  }

  carrierCleared() {
    this.selectedCarrierChange.emit(null);
  }

  regionCleared() {
    this.selectedRegionChange.emit(null);
  }

  toggleHelper() {
    this.helperActive = !this.helperActive;
  }
}
